// extracted by mini-css-extract-plugin
var _1 = "CalendarFollowUpCapModal-moduleskeleton__fV7Ae Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
